import { get, isFinite } from 'lodash';
import { defaultBodyBorderWidth } from '../message-defaults';
export const getBodyBorderWidth = (composerData) => {
    const getBorderWidth = (path) => parseInt(get(composerData, path), 10);
    const customBorderWidth = getBorderWidth('background.body.borderWidth');
    if (isFinite(customBorderWidth)) {
        return customBorderWidth;
    }
    const fallbackBorderWidth = getBorderWidth('styles.css.so-global-body.borderWidth');
    if (isFinite(fallbackBorderWidth)) {
        return fallbackBorderWidth;
    }
    return defaultBodyBorderWidth;
};
//# sourceMappingURL=get-body-border-width.js.map